// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__10gJ5","consentsList":"PatientConsents_consentsList__RdaMQ","consentsListEmpty":"PatientConsents_consentsListEmpty__2WzTk"};